module.exports = __webpack_public_path__ + "static/media/ninecodeCircle.2c99505e.svg";